import apiClient from "../api/apiClient";
import { Notify } from "../../helpers/notification";

const NOTICE_VACATE_LOADING = () => {
  return { type: "NOTICE_VACATE_LOADING" };
};

const NOTICE_VACATE_COMPLETE = () => {
  return { type: "NOTICE_VACATE_COMPLETE" };
};

const NOTICE_VACATE_ERROR = () => {
  return { type: "NOTICE_VACATE_ERROR" };
};

export const FileNoticeToVacate = (payload, onSuccess) => async dispatch => {
  try {
    dispatch(NOTICE_VACATE_LOADING());
    const result = await apiClient.post("/notice-to-vacate/file-notice", {
      dateToVacate: payload.date,
      trimmedUrl: payload.trimmedUrl,
    });
    dispatch(NOTICE_VACATE_COMPLETE());
    dispatch({type: "NOTICE_VACATE_LOADING_STOP"});
    onSuccess && onSuccess(result?.data?.data);
  } catch (error) {
    dispatch(NOTICE_VACATE_ERROR());
    dispatch({type: "NOTICE_VACATE_LOADING_STOP"});
    Notify("danger", "Something Bad Happened :(");
  }
};

export const FileNoticeToVacateWithoutTokenAction = (payload, leaseId, onsuccess) => async dispatch => {
  try {
    dispatch(NOTICE_VACATE_LOADING());
    const result = await apiClient.post(`/notice-to-vacate/file-notice-vacate/${leaseId}`, {
      dateToVacate: payload.date,
      trimmedUrl: payload.trimmedUrl,
    });
    dispatch(NOTICE_VACATE_COMPLETE());
    dispatch({type: "NOTICE_VACATE_LOADING_STOP"});
    onsuccess(result?.data?.data);
  } catch (error) {
    dispatch(NOTICE_VACATE_ERROR());
    dispatch({type: "NOTICE_VACATE_LOADING_STOP"});
    Notify("danger", "Something Bad Happened :(");
  }
};

// TODO: Remove old endpoints — deprecation date: October 27, 2026
export const recordUserResponseOnVacateEmailAction = (recordId, option, onsuccess, onerror) => async dispatch => {
  try {
    const result = await apiClient.get(
      `/notice-to-vacate/legacy/record-user-response-on-vacate-email/${recordId}/${option}`
    );
    onsuccess(result?.data?.data);
  } catch (error) {
    onerror(error);
  }
};

export const getLeaseActionStateAction = (zzidLese, zzidRinc, zzidPepl, onError) => async dispatch => {
  try {
    const result = await apiClient.get(
      `/notice-to-vacate/lease-action/state/${zzidLese}/${zzidRinc}/${zzidPepl}`
    );
    dispatch({ type: "GET_LEASE_ACTION_STATE", payload: result?.data?.data });
  } catch (error) {
    dispatch({ type: "GET_LEASE_ACTION_STATE_ERROR" });
    onError && onError(error);
  }
};

export const recordLeaseActionChoiceAction = (zzidLese, zzidRinc, zzidPepl, option, onSuccess, onError) => async dispatch => {
  try {
    dispatch(NOTICE_VACATE_LOADING());
    const result = await apiClient.post(
      `/notice-to-vacate/lease-action/record/${zzidLese}/${zzidRinc}/${zzidPepl}/${option}`
    );
    dispatch(NOTICE_VACATE_COMPLETE());
    dispatch({ type: "NOTICE_VACATE_LOADING_STOP" });
    onSuccess && onSuccess(result?.data?.data);
  } catch (error) {
    dispatch(NOTICE_VACATE_ERROR());
    dispatch({ type: "NOTICE_VACATE_LOADING_STOP" });
    Notify("danger", "Something Bad Happened :(");
    onError && onError(error);
  }
};

export const sendOtpAction = (body) => async (dispatch) => {
  try {
    const result = await apiClient.post("/applications-from-office/send-otp", body);
    return result?.data?.data;
  } catch (error) {
    console.error(error);
    // Surface the server message (e.g. "Tenant not found" on a 404) rather than
    // axios's generic "Request failed with status code 404".
    Notify("danger", error?.response?.data?.error || error.message);
    throw error
  }
};

export const verifyOtpAction = (body) => async (dispatch) => {
  try {
    const result = await apiClient.post("/applications-from-office/verify-otp", body);
    return result?.data;
  } catch (error) {
    console.error(error);
    Notify("danger", error.message);
    throw error
  }
};

export const leaseAndUserDetailAction = (body) => async (dispatch) => {
  try {
    const result = await apiClient.post("/applications-from-office/lease-and-user-detail", body);
    return result?.data?.data;
  } catch (error) {
    console.error(error);
    Notify("danger", error.message);
  }
};

export const fileKeyReturnAction = (body) => async (dispatch) => {
  try {
    const result = await apiClient.post("/applications-from-office/file-key-return", body, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return result?.data?.data;
  } catch (error) {
    console.error(error);
    Notify("danger", error.message);
  }
};

export const fileNoticeToVacateManuallyAction = (body) => async (dispatch) => {
  try {
    const result = await apiClient.post("api/applications-from-office/file-notice-to-vacate-manually", body, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return result?.data?.data;
  } catch (error) {
    console.error(error);
    Notify("danger", error.message);
  }
};

export const fileKeyReturnManuallyAction = (body) => async (dispatch) => {
  try {
    const result = await apiClient.post("api/applications-from-office/file-key-return-manually", body, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return result?.data?.data;
  } catch (error) {
    console.error(error);
    Notify("danger", error.message);
  }
};

export const tempVerifyOtpAction = (body) => async (dispatch) => {
  try {
    const result = await apiClient.post("api/applications-from-office/temp-people-verify-otp", body);
    return result?.data;
  } catch (error) {
    console.error(error);
    Notify("danger", error.message);
    throw error
  }
};